import yup from '../libs/yup'
import { masks } from '../utils/masks'
import { validarCPF } from '../utils/validateDocuments'

export type UserRegisterForm = {
  _id?: string
  name: string
  photo?: any
  document: string
  state: string
  city: string
  manager: boolean
  email: string
  portariaNomeacao: string
  vigenciaNomeacao: string
  password?: string
  confirmPassword?: string
  role: string
}

export type UserForgotChangePasswordForm = {
  email: string
  password: string
  confirmPassword: string
}

export type UserForgotForm = {
  email: string
  password: string
}

export type UserLoginForm = {
  document: string
  password: string
}

export const forgotSchema = yup.object().shape({
  email: yup.string().required().email().label('E-mail'),
})

export const updateUserSchema = yup.object().shape({
  name: yup.string().required().label('Nome'),
})

export const forgotChangePasswordSchema = yup.object().shape({
  password: yup.string().required().min(6).max(40).label('Senha'),
  confirmPassword: yup
    .string()
    .label('Confirmar Senha')
    .required()
    .oneOf([yup.ref('password'), ''], 'Senhas devem ser iguais'),
})

export const loginSchema = yup.object().shape({
  document: yup.string().required().label('CPF'),
  password: yup.string().required().min(6).max(40).label('Senha'),
})

export const updateSchema = yup.object().shape({
  name: yup.string().required().label('Nome'),
  email: yup.string().required().email().label('E-mail'),
  photo: yup.mixed().label('Logo'),
  document: yup
    .string()
    .required()
    .test('CPF inválido', 'CPF inválido', (val: any = '') => {
      let document = masks.unmask(val)
      return validarCPF(document)
    })
    .label('CPF'),
  state: yup.string().required().label('Estado'),
  city: yup.string().required().label('Cidade'),
  manager: yup.boolean().label('Gestor'),
  portariaNomeacao: yup
    .string()
    .when(['manager'], {
      is: (type: any) => Boolean(type) === true,
      then: () => yup.string().required(),
    })
    .label('Portaria de Nomeação'),
  vigenciaNomeacao: yup
    .string()
    .when(['manager'], {
      is: (type: any) => Boolean(type) === true,
      then: () => yup.string().required(),
    })
    .label('Vigência de Nomeação'),
  password: yup.string().label('Senha'),
  role: yup.string().required().label('Perfil'),
})

export const registerSchema = yup.object().shape({
  name: yup.string().required().label('Nome'),
  email: yup.string().required().email().label('E-mail'),
  logo: yup.mixed().label('Logo'),
  document: yup
    .string()
    .required()
    .test('CPF inválido', 'CPF inválido', (val: any = '') => {
      let document = masks.unmask(val)
      return validarCPF(document)
    })
    .label('CPF'),
  state: yup.string().required().label('Estado'),
  city: yup.string().required().label('Cidade'),
  manager: yup.boolean().label('Gestor'),
  portariaNomeacao: yup
    .string()
    .when(['manager'], {
      is: (type: any) => Boolean(type) === true,
      then: () => yup.string().required(),
    })
    .label('Portaria de Nomeação'),
  vigenciaNomeacao: yup
    .string()
    .when(['manager'], {
      is: (type: any) => Boolean(type) === true,
      then: () => yup.string().required(),
    })
    .label('Vigência de Nomeação'),
  password: yup.string().required().label('Senha').min(6).max(40),
  confirmPassword: yup
    .string()
    .label('Confirmar Senha')
    .required()
    .oneOf([yup.ref('password'), ''], 'Senhas devem ser iguais'),
  role: yup.string().required().label('Perfil'),
})
